export default __webpack_public_path__ + "static/media/stepstoimport.566fba3a.svg";